import React from "react";
import "./Skeleton.scss";

export function SkeletonBlock({ width = "100%", height = 16, className = "", pill = false }) {
  return (
    <div
      className={`hb_skeleton${pill ? " hb_skeleton--pill" : ""} ${className}`.trim()}
      style={{ width, height }}
      aria-hidden
    />
  );
}

export function SkeletonText({ lines = 3, lineHeight = 12, gap = 8 }) {
  return (
    <div className="hb_skeleton_text" aria-hidden>
      {Array.from({ length: lines }).map((_, idx) => (
        <SkeletonBlock
          key={idx}
          height={lineHeight}
          width={idx === lines - 1 ? "70%" : "100%"}
          className="hb_skeleton_text_line"
        />
      ))}
      <style>{`.hb_skeleton_text_line + .hb_skeleton_text_line{margin-top:${gap}px;}`}</style>
    </div>
  );
}

